
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalBase from '@/components/atoms/ModalBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'

/**
 * モーダルウィンドウ
 *
 * slotで渡したコンテンツをモーダル表示する
 * コンテンツが指定サイズを超えた場合は自動的に内部スクロールが発生(可変サイズは不安定な部分が多いため使用していない)
 *   タイトル部分は固定でコンテンツのみスクロールなどさせたい場合は個別に実装する
 *
 * TIPS
 *   モーダル内の背景色を変える場合、slotで渡すコンテンツのmin-heightを100%にして背景色を指定すればOK。
 *   逆にルート要素の背景色を指定した場合、オーバーレイ部分の色として指定されてしまう。
 *
 *   独自の閉じるボタンなどを実装する場合、slotで渡すコンテンツに含め、refを使ってこのコンポーネントのshowやhideを呼び出す。
 */
@Component({
  components: {
    ModalBase,
    ImageBase,
  },
})
export default class ModalWindow extends Vue {
  /** モーダル表示幅(px) - 必須 */
  @Prop()
  width!: number

  /** モーダル表示高さ(px) - 必須 */
  @Prop()
  height!: number

  /**
   * 背景クリック時にモーダルを閉じるか否か(ライブラリオプション)
   *   未指定時は閉じる
   */
  @Prop({ default: true })
  clickToClose!: boolean

  /**
   * モーダルをドラッグ可能にするか否か(ライブラリオプション)
   *   未指定時はOFF=位置固定
   *   trueの場合は全範囲ドラッグ可能
   *   文字列(CSSセレクタ)指定時は対象箇所がドラッグ可能に
   */
  @Prop({ default: false })
  draggable!: boolean | string

  /**
   * 右上の閉じるボタンを表示するか否か
   *   未指定時は表示する
   *   表示する場合はslotの要素にmarginやpaddingなどを適切に設定すること
   */
  @Prop({ default: true })
  showCloseButton!: boolean

  /** モーダル基底部品 */
  @Ref()
  modalBase!: ModalBase

  /** モーダルのボックス部分に適用するcssクラス(今後の拡張に対応しやすいよう、現状は固定だが定数化) */
  private readonly CLASSES = ['modal-box-default']

  /**
   * モーダルの表示処理
   */
  public show(): void {
    this.modalBase.show()
  }

  /**
   * モーダルの消去処理
   */
  public hide(): void {
    this.modalBase.hide()
  }

  /**
   * モーダル消去完了時のイベントを通知
   *   使用時に@closed='function'と設定すればモーダル消去後に処理の実行が可能
   */
  private closed(): void {
    this.$emit('closed')
  }
}
